import { ReactElement } from 'react';
import ArrowUp from '@src/sld/components/ArrowUp/ArrowUp';
import VerticalLine from '@src/sld/components/Line/VerticalLine';
import HorizontalLine from '@src/sld/components/Line/HorizontalLine';
import Circle from '@src/sld/components/Circle/Circle';

function Header(): ReactElement {
  return (
    <>
      <text
        x={700}
        y={60}
        fontSize={8}
        fill='white'
        stroke='white'
        strokeWidth={0.2}
      >
        138 kV Fort Bend Switch
      </text>

      <ArrowUp xCoordinate={740} yCoordinate={80} />

      <VerticalLine
        translateXCoordinate={742.5}
        translateYCoordinate={80}
        length={50}
        color='white'
        width={0.5}
      />

      <HorizontalLine
        translateXCoordinate={737.5}
        translateYCoordinate={130}
        length={10}
        color='white'
        width={0.5}
      />

      <Circle
        translateXCoordinate={742.5}
        translateYCoordinate={132}
        diameter={4}
        stroke='white'
        strokeWidth={2}
        label=''
      />
    </>
  );
}

export default Header;
